module.exports = __webpack_public_path__ + "img/verifikasi_email.d583657e.png";